/**
 * Usage:
 *
 * Step 1: Somewhere in JS...
 *   import Alpine from "alpinejs";
 *   import spine from "./tabbedSection";
 *   Alpine.data('tabbedSection', tabbedSection);
 *   Alpine.start();
 *
 * Step 2: Somewhere in markup...
 *   <div x-data="tabbedSection()" />
 *
 * @param selector
 * @returns {{init(): void, el: null, selector: null}}
 */
export default (tabs = null) => ({

  activeIndex: 1,
  tabs: tabs,

  init() {
    if (this.tabs) {
      this.updateTab(this.tabs[0], 1);
    }
  },

  updateTab(loopIndex) {
    this.activeIndex = loopIndex;
  },
});
